<template>
  <iframe border="0" style="width: 100%; height: 100%;border: none;background-color: #fff;" :src="url"/>
</template>

<script>
export default {
  name: "detail",
  data() {
    return {
      url: ''
    }
  },
  mounted() {
    // 监听子页面想父页面的传参
    window.addEventListener('message',function(event){
      //此处执行事件
      console.log('监听到子页面的传参')
      console.log(event.data)
    })
  },
  created() {
    this.url = decodeURI(this.$route.query.url)
  }
}
</script>

<style scoped>

</style>